module.exports = __webpack_public_path__ + "static/media/SWSCRC1-28.e7dc573a.mp3";